module.exports = __webpack_public_path__ + "img/hand-money.f5ea0f16.png";